import { useRef } from "react";
import { ServiceLocationModel } from "../../data/entities";
import { ServiceLocationService } from "../../services";
import { useCRUDHandlers, useSetPageTitle, useSharedState, useUrlParams } from "../../hooks";
import { Breakpoints, ODataGrid, ResponsiveGridColumn, TitlelessCard } from "../../components";
import { createODataQueryFilter, formatPrice } from "../../utils";

export function LocationPricingPage() {

  const id = parseInt(useUrlParams("id"));
  const gridRef = useRef<ODataGrid>(null);
  const gridData = useSharedState<Array<ServiceLocationModel>>([]);
  const serviceLocationService = new ServiceLocationService();
  const { getItems } = useCRUDHandlers<ServiceLocationModel>(serviceLocationService, "Service Location");


  useSetPageTitle("Pricing", []);

  const priceCell = (props: any) => {
    const value = props.dataItem.price ?? props.dataItem.service?.defaultPrice;
    const className = props.dataItem.price ? "fw-semibold" :"text-light-muted";
    return (
      <td className={className}>
        {value !== null && value !== undefined ? formatPrice(value) : "N/A"}
      </td>
    );
  };

  return (
    <TitlelessCard bodyClassName="p-0">
      <ODataGrid
        ref={gridRef}
        getData={(oDataQuery) => {
          const locationFilter = [`locationId eq ${id}`]
          const filterQuery = createODataQueryFilter(oDataQuery, locationFilter)
          return getItems(`${filterQuery}&$expand=Service`)
        }}
        dataState={gridData}
        sort={[{ field: "service.name", dir: "asc"}]}
        scrollable="scrollable"
        pageSize={10}
      >
        <ResponsiveGridColumn
          title="Service"
          field="service.name"
          sortable={true}
          width={"auto"}
        />
        <ResponsiveGridColumn
          title="Price"
          field="price"
          format="{0:C}"
          filterable={false}
          sortable={true}
          cells={{ data: priceCell }}
          filter="numeric"
          width={"auto"}
        />
      </ODataGrid>
    </TitlelessCard>
  );
}

export default LocationPricingPage;

